export default __webpack_public_path__ + "static/media/material-count.d1b38b46.svg";